import React from 'react';

export interface RenderingContext {
    type: 'default' | 'isolated';
    gfxLevel: number;
}

export const RenderingContext = React.createContext<RenderingContext | null>({
    type: 'default',
    gfxLevel: 2,
});
